var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('img',{staticClass:"sword-logo",attrs:{"src":require("@/assets/full-logo.svg"),"alt":"SWORD Health"}})])
}]

export { render, staticRenderFns }